import React from 'react'
import './PhoneInputComponent.scoped.sass'

import PhoneInput from 'react-phone-number-input'
import flags from 'react-phone-number-input/flags'
import 'react-phone-number-input/style.css'

export function PhoneInputComponent (props) {
  const { phoneNumber, setPhoneNumber } = props
  return (
    <div className='phone-input-div'>
      <PhoneInput
        flags={flags}
        className='phone-input'
        placeholder='Enter phone number...'
        value={phoneNumber}
        onChange={setPhoneNumber}
      />
    </div>
  )
}
